import { Component, OnInit ,AfterViewChecked} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NotificationService } from '@app/shared/services/notification.service';
declare const mermaid: any;


@Component({
  selector: 'app-sap-details-dashboard',
  templateUrl: './sap-details.component.html',
  styleUrls: ['./sap-details.component.scss']
})

export class SapDetailsDashboardComponent implements OnInit ,AfterViewChecked{
  public nonceValue = (window as any).cspNonce;
  public userId: string = '';
  public userIdJustification: string = '';
  public controlGroupId: string = '';
  public userResponse: any = null;
  public extendedResponse: any = null;
  public justificationResponse: any = null;
  public errorMessage: string = '';
  public isLoading: boolean = false;
  public activeTab: string = 'sapResponse';
  public resultFlag: string = ''; // Store YES/NO result
  public justificationDetails: string = ''; // Store justification text
  public mermaidDiagram: string = ''; // Mermaid.js diagram
  public highlightedNodes: string[] = []; // To track highlighted flowchart nodes
  private mermaidInitialized: boolean = false; // Track if Mermaid has been initialized
  public controlGroups: string[] = []; // List of control groups for dropdown
  public isJustifyDisabled: boolean = false; //
  
  

  constructor(private http: HttpClient, private notificationService: NotificationService) {}
  ngOnInit(): void {
    setTimeout(() => {
      this.mermaidInitialized = true; // Mark as initialized
      // Re-render the diagram
      this.renderMermaidDiagram();
    }, 1000);
        // Fetch control groups for dropdown
        this.fetchControlGroups();
  }
  

  /**
   * Set the active tab
   */
  setActiveTab(tab: string): void {
    this.activeTab = tab;
  }

  /**
   * Fetch control groups from backend
   */
   fetchControlGroups(): void {
    const apiUrl = `rest/sapdetails/controlgroups`;

    this.http.get<string[]>(apiUrl).subscribe({
      next: (response: string[]) => {
        this.controlGroups = response || [];
      },
      error: (err) => {
        console.error('Error fetching control groups:', err);
        this.notificationService.showError(
          'Failed to retrieve control groups. Please try again later.'
        );
        this.errorMessage = 'Error fetching control groups.';
      }
    });
  }

  /**
   * Fetch SAP details from backend
   */
  getDetails() {
    if (!this.userId) {
      this.errorMessage = 'User ID is required.';
      return;
    }
  
    this.errorMessage = '';
    this.isLoading = true;
    const apiUrl = `rest/sapdetails/${this.userId}`;
  
    this.http.post(apiUrl, {}, { responseType: 'text' }).subscribe({
      next: (response: string) => {
        this.isLoading = false; // Stop the spinner for the button
        // Check if the response is the string "Null"
        if (response === 'Null') {
          this.errorMessage = 'User ID is not present in employee central.';
          this.userResponse = null;
          this.extendedResponse = null;
        } else {
          try {
            const parsedResponse = JSON.parse(response); // Try parsing the JSON
            this.userResponse = parsedResponse.masterData || null;
            this.extendedResponse = parsedResponse.extendedData || null;
  
            // If both responses are null, show error message
            if (!this.userResponse && !this.extendedResponse) {
              this.errorMessage = 'User ID is not present in employee central.';
            }
          } catch (e) {
            // Handle case where the response is not valid JSON
            this.errorMessage = 'Error parsing the response from the server.';
          }
        }
      },
      error: (err) => {
        console.error('Error fetching SAP details:', err);
        this.notificationService.showError(
          'Failed to retrieve SAP details. Please try again later.'
        );
        this.errorMessage = 'Error retrieving SAP details.';
        this.isLoading = false;
      }
    });
  }

  /**
   * Perform justification
   */
  justify() {
    if (!this.userIdJustification || !this.controlGroupId) {
      this.errorMessage = 'Both User ID and Control Group ID are required for Justification.';
      return;
    }

    this.errorMessage = '';
    this.isLoading = true;
    this.isJustifyDisabled = true;

    const justificationUrl = `rest/sapdetails/${this.userIdJustification}/${this.controlGroupId}`;

    const requestPayload = {
      userId: this.userIdJustification,
      controlGroupId: this.controlGroupId
    };

    this.http.post(justificationUrl, requestPayload, { responseType: 'text' }).subscribe({
      next: (response: string) => {
        this.isLoading = false;

        if (response === 'Null') {
          // Handle "Null" response
          this.errorMessage = 'User ID is not present in employee central and Invalid Control Group';
          this.resultFlag = '';
          this.justificationDetails = '';
          return;
        }
  
        if (response === 'Invalid CGID') {
          // Handle "Invalid CGID" response
          this.errorMessage = 'Please provide valid Control Group.';
          this.resultFlag = '';
          this.justificationDetails = '';
          return;
        }
        if (response === 'Invalid UserID') {
          // Handle "Invalid UserID" response
          this.errorMessage = 'User ID is not present in employee central.';
          this.resultFlag = '';
          this.justificationDetails = '';
          return;
        }
        if (response === 'UserID is not present in the User Information Page') {
          // Handle "Invalid CGID" response
          this.errorMessage = 'User ID is not present in the User Information Page.';
          this.resultFlag = '';
          this.justificationDetails = '';
          return;
        }

        // Parse response and extract details after '||'
        const splitResponse = response.split('||');
        if (splitResponse.length === 2) {
          const flag = splitResponse[0].trim();
          const message = splitResponse[1].trim();
          
          this.resultFlag = flag.includes('Yes') ? 'Yes Flag' : flag.includes('No') ? 'No Flag' : '';
          this.justificationDetails = message;
        } else {
          this.resultFlag = '';
          this.justificationDetails = 'Invalid response received.';
        }
          // Update the flowchart based on the response
          this.updateMermaidDiagram(response);
                
      },
      error: (err) => {
        console.error('Error performing justification:', err);
        this.notificationService.showError(
          'Failed to perform justification. Please try again later.'
        );
        this.errorMessage = 'Error performing justification.';
        this.isLoading = false;
      }
    });
  }
   /**
   * Update the Mermaid.js diagram based on the response
   */
   updateMermaidDiagram(response: string): void {
    const splitResponse = response.split('||');
    if (splitResponse.length === 2) {
      const flag = splitResponse[0].trim();
      const message = splitResponse[1].trim();

      this.highlightedNodes = []; // Reset highlighted nodes for every response

      // Logic to highlight flowchart nodes
      switch (true) {
        case message.includes("whitelisted"):
          this.mermaidDiagram =
            `graph LR
              A[Start] -.-> B{"<strong> Verify <br> whether provided <br> Control Group is <br> Whitelisted </strong>"}
              B -.->|Yes| C[Yes Flag]
              B -->|No| D{Verify <br> whether provided <br> Control Group is <br> Blacklisted}
              D -->|Yes| J
              D -->|No| E{Check <br> whether provided <br> User's Company is <br> License authorized }
              E -->|Yes| C
              E -->|No| H{Users <br>company and site <br> present in master data}
              H -->|Yes| I{Check <br> provided CGID is <br> in Control group country}
              H -->|No| J[No Flag]
              I -->|Yes| K{Validation for <br>users extended data <br> profile information}
              I -->|No| J
              K -->|Yes| C
              K -->|No| J


              %% Styling for decision nodes and others
              style A fill:#D5DBDB,stroke:#1D3557;
              style B fill:#faee82,stroke:#1D3557,stroke-width:2px;
              style D fill:#faee82,stroke:#1D3557,stroke-width:2px;
              style E fill:#faee82,stroke:#1D3557,stroke-width:2px;
              style H fill:#faee82,stroke:#1D3557,stroke-width:2px;
              style I fill:#faee82,stroke:#1D3557,stroke-width:2px;
              style K fill:#faee82,stroke:#1D3557,stroke-width:2px;

              %% Define classes for specific nodes
              classDef whiteText fill:#0AB134,stroke:#1D3557,color:white;
              classDef redText fill:#F6332C,stroke:#1D3557,color:white;

              %% Apply classes to specific nodes
              class C whiteText;
              class J redText;

              %% Link styles for clarity
              linkStyle 0 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
              linkStyle 1 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
              linkStyle 2 stroke:#F6332C,stroke-width:2px;
              linkStyle 3 stroke:#0AB134,stroke-width:2px;
              linkStyle 4 stroke:#F6332C,stroke-width:2px;
              linkStyle 5 stroke:#0AB134,stroke-width:2px;
              linkStyle 6 stroke:#F6332C,stroke-width:2px;
              linkStyle 7 stroke:#0AB134,stroke-width:2px;
              linkStyle 8 stroke:#F6332C,stroke-width:2px;
              linkStyle 9 stroke:#0AB134,stroke-width:2px;
              linkStyle 10 stroke:#F6332C,stroke-width:2px;
              linkStyle 11 stroke:#0AB134,stroke-width:2px;
              linkStyle 12 stroke:#F6332C,stroke-width:2px;

            `;
          break;
        case message.includes("blacklisted"):
          this.mermaidDiagram =
            `graph LR
            A[Start] -.-> B{"<strong> Verify <br> whether provided <br> Control Group is <br> Whitelisted </strong>"}
            B -->|Yes| C[Yes Flag]
            B -.->|No| D{<strong> Verify <br> whether provided <br> Control Group is <br> Blacklisted </strong>}
            D -.->|Yes| J
            D -->|No| E{Check <br> whether provided <br> User's Company is <br> License authorized }
            E -->|Yes| C
            E -->|No| H{Users <br>company and site <br> present in master data}
            H -->|Yes| I{Check <br> provided CGID is <br> in Control group country}
            H -->|No| J[No Flag]
            I -->|Yes| K{Validation for <br>users extended data <br> profile information}
            I -->|No| J
            K -->|Yes| C
            K -->|No| J


            %% Styling for decision nodes and others
            style A fill:#D5DBDB,stroke:#1D3557;
            style B fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style D fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style E fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style H fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style I fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style K fill:#faee82,stroke:#1D3557,stroke-width:2px;

            %% Define classes for specific nodes
            classDef whiteText fill:#0AB134,stroke:#1D3557,color:white;
            classDef redText fill:#F6332C,stroke:#1D3557,color:white;

            %% Apply classes to specific nodes
            class C whiteText;
            class J redText;

            %% Link styles for clarity
            linkStyle 0 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 1 stroke:#0AB134,stroke-width:2px;
            linkStyle 2 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 3 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 4 stroke:#F6332C,stroke-width:2px;
            linkStyle 5 stroke:#0AB134,stroke-width:2px;
            linkStyle 6 stroke:#F6332C,stroke-width:2px;
            linkStyle 7 stroke:#0AB134,stroke-width:2px;
            linkStyle 8 stroke:#F6332C,stroke-width:2px;
            linkStyle 9 stroke:#0AB134,stroke-width:2px;
            linkStyle 10 stroke:#F6332C,stroke-width:2px;
            linkStyle 11 stroke:#0AB134,stroke-width:2px;
            linkStyle 12 stroke:#F6332C,stroke-width:2px;
            `;
          break;
        case message.includes("authorized in company license"):
          this.mermaidDiagram = 
            `graph LR
            A[Start] -.-> B{"<strong> Verify <br> whether provided <br> Control Group is <br> Whitelisted </strong>"}
            B -->|Yes| C[Yes Flag]
            B -.->|No| D{<strong> Verify <br> whether provided <br> Control Group is <br> Blacklisted </strong>}
            D -->|Yes| J
            D -.->|No| E{<strong>Check <br> whether provided <br> User's Company is <br> License authorized </strong> }
            E -.->|Yes| C
            E -->|No| H{Users <br>company and site <br> present in master data}
            H -->|Yes| I{Check <br> provided CGID is <br> in Control group country}
            H -->|No| J[No Flag]
            I -->|Yes| K{Validation for <br>users extended data <br> profile information}
            I -->|No| J
            K -->|Yes| C
            K -->|No| J


            %% Styling for decision nodes and others
            style A fill:#D5DBDB,stroke:#1D3557;
            style B fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style D fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style E fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style H fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style I fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style K fill:#faee82,stroke:#1D3557,stroke-width:2px;

            %% Define classes for specific nodes
            classDef whiteText fill:#0AB134,stroke:#1D3557,color:white;
            classDef redText fill:#F6332C,stroke:#1D3557,color:white;

            %% Apply classes to specific nodes
            class C whiteText;
            class J redText;

            %% Link styles for clarity
            linkStyle 0 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 1 stroke:#0AB134,stroke-width:2px;
            linkStyle 2 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 3 stroke:#0AB134,stroke-width:2px;
            linkStyle 4 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 5 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 6 stroke:#F6332C,stroke-width:2px;
            linkStyle 7 stroke:#0AB134,stroke-width:2px;
            linkStyle 8 stroke:#F6332C,stroke-width:2px;
            linkStyle 9 stroke:#0AB134,stroke-width:2px;
            linkStyle 10 stroke:#F6332C,stroke-width:2px;
            linkStyle 11 stroke:#0AB134,stroke-width:2px;
            linkStyle 12 stroke:#F6332C,stroke-width:2px;
            `;
          break;
        case message.includes("not present in Company master data")|| message.includes("missing in Site master list") || message.includes("User does not have a proper company country"):
          this.mermaidDiagram = 
            `graph LR
            A[Start] -.-> B{"<strong> Verify <br> whether provided <br> Control Group is <br> Whitelisted </strong>"}
            B -->|Yes| C[Yes Flag]
            B -.->|No| D{<strong> Verify <br> whether provided <br> Control Group is <br> Blacklisted </strong>}
            D -->|Yes| J
            D -.->|No| E{<strong>Check <br> whether provided <br> User's Company is <br> License authorized </strong> }
            E -->|Yes| C
            E -.->|No| H{<strong> Users <br>company and site <br> present in master data </strong>}
            H -->|Yes| I{ Check <br> provided CGID is <br> in Control group country}
            H -.->|No| J[No Flag]
            I -->|Yes| K{Validation for <br>users extended data <br> profile information}
            I -->|No| J
            K -->|Yes| C
            K -->|No| J


            %% Styling for decision nodes and others
            style A fill:#D5DBDB,stroke:#1D3557;
            style B fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style D fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style E fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style H fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style I fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style K fill:#faee82,stroke:#1D3557,stroke-width:2px;

            %% Define classes for specific nodes
            classDef whiteText fill:#0AB134,stroke:#1D3557,color:white;
            classDef redText fill:#F6332C,stroke:#1D3557,color:white;

            %% Apply classes to specific nodes
            class C whiteText;
            class J redText;

            %% Link styles for clarity
            linkStyle 0 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 1 stroke:#0AB134,stroke-width:2px;
            linkStyle 2 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 3 stroke:#0AB134,stroke-width:2px;
            linkStyle 4 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 5 stroke:#0AB134,stroke-width:2px;
            linkStyle 6 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 7 stroke:#0AB134,stroke-width:2px;
            linkStyle 8 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 9 stroke:#0AB134,stroke-width:2px;
            linkStyle 10 stroke:#F6332C,stroke-width:2px;
            linkStyle 11 stroke:#0AB134,stroke-width:2px;
            linkStyle 12 stroke:#F6332C,stroke-width:2px;

            `;
          break;
        case message.includes("not present in control group country list"):
          this.mermaidDiagram = 
            `graph LR
            A[Start] -.-> B{"<strong> Verify <br> whether provided <br> Control Group is <br> Whitelisted </strong>"}
            B -->|Yes| C[Yes Flag]
            B -.->|No| D{<strong> Verify <br> whether provided <br> Control Group is <br> Blacklisted </strong>}
            D -->|Yes| J
            D -.->|No| E{<strong>Check <br> whether provided <br> User's Company is <br> License authorized </strong> }
            E -->|Yes| C
            E -.->|No| H{<strong> Users <br>company and site <br> present in master data </strong>}
            H -.->|Yes| I{<strong> Check <br> provided CGID is <br> in Control group country </strong>}
            H -->|No| J[No Flag]
            I -->|Yes| K{Validation for <br>users extended data <br> profile information }
            I -.->|No| J
            K -->|Yes| C
            K -->|No| J


            %% Styling for decision nodes and others
            style A fill:#D5DBDB,stroke:#1D3557;
            style B fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style D fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style E fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style H fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style I fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style K fill:#faee82,stroke:#1D3557,stroke-width:2px;

            %% Define classes for specific nodes
            classDef whiteText fill:#0AB134,stroke:#1D3557,color:white;
            classDef redText fill:#F6332C,stroke:#1D3557,color:white;

            %% Apply classes to specific nodes
            class C whiteText;
            class J redText;

            %% Link styles for clarity
            linkStyle 0 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 1 stroke:#0AB134,stroke-width:2px;
            linkStyle 2 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 3 stroke:#0AB134,stroke-width:2px;
            linkStyle 4 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 5 stroke:#0AB134,stroke-width:2px;
            linkStyle 6 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 7 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 8 stroke:#F6332C,stroke-width:2px;
            linkStyle 9 stroke:#0AB134,stroke-width:2px;
            linkStyle 10 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 11 stroke:#0AB134,stroke-width:2px;
            linkStyle 12 stroke:#F6332C,stroke-width:2px;
            `;
          break;
        case message.includes("profile has been verified"):
          this.mermaidDiagram = 
            `graph LR
            A[Start] -.-> B{"<strong> Verify <br> whether provided <br> Control Group is <br> Whitelisted </strong>"}
            B -->|Yes| C[Yes Flag]
            B -.->|No| D{<strong> Verify <br> whether provided <br> Control Group is <br> Blacklisted </strong>}
            D -->|Yes| J
            D -.->|No| E{<strong>Check <br> whether provided <br> User's Company is <br> License authorized </strong> }
            E -->|Yes| C
            E -.->|No| H{<strong> Users <br>company and site <br> present in master data </strong>}
            H -.->|Yes| I{<strong> Check <br> provided CGID is <br> in Control group country </strong>}
            H -->|No| J[No Flag]
            I -.->|Yes| K{<strong> Validation for <br>users extended data <br> profile information </strong>}
            I -->|No| J
            K -.->|Yes| C
            K -->|No| J


            %% Styling for decision nodes and others
            style A fill:#D5DBDB,stroke:#1D3557;
            style B fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style D fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style E fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style H fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style I fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style K fill:#faee82,stroke:#1D3557,stroke-width:2px;

            %% Define classes for specific nodes
            classDef whiteText fill:#0AB134,stroke:#1D3557,color:white;
            classDef redText fill:#F6332C,stroke:#1D3557,color:white;

            %% Apply classes to specific nodes
            class C whiteText;
            class J redText;

            %% Link styles for clarity
            linkStyle 0 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 1 stroke:#0AB134,stroke-width:2px;
            linkStyle 2 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 3 stroke:#0AB134,stroke-width:2px;
            linkStyle 4 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 5 stroke:#0AB134,stroke-width:2px;
            linkStyle 6 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 7 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 8 stroke:#F6332C,stroke-width:2px;
            linkStyle 9 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 10 stroke:#F6332C,stroke-width:2px;
            linkStyle 11 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 12 stroke:#F6332C,stroke-width:2px;

            `;
          break;
        case message.includes("not verified"):
          this.mermaidDiagram = 
            `graph LR
            A[Start] -.-> B{"<strong> Verify <br> whether provided <br> Control Group is <br> Whitelisted </strong>"}
            B -->|Yes| C[Yes Flag]
            B -.->|No| D{<strong> Verify <br> whether provided <br> Control Group is <br> Blacklisted </strong>}
            D -->|Yes| J
            D -.->|No| E{<strong>Check <br> whether provided <br> User's Company is <br> License authorized </strong> }
            E -->|Yes| C
            E -.->|No| H{<strong> Users <br>company and site <br> present in master data </strong>}
            H -.->|Yes| I{<strong> Check <br> provided CGID is <br> in Control group country </strong>}
            H -->|No| J[No Flag]
            I -.->|Yes| K{<strong> Validation for <br>users extended data <br> profile information </strong>}
            I -->|No| J
            K -->|Yes| C
            K -.->|No| J


            %% Styling for decision nodes and others
            style A fill:#D5DBDB,stroke:#1D3557;
            style B fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style D fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style E fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style H fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style I fill:#faee82,stroke:#1D3557,stroke-width:2px;
            style K fill:#faee82,stroke:#1D3557,stroke-width:2px;

            %% Define classes for specific nodes
            classDef whiteText fill:#0AB134,stroke:#1D3557,color:white;
            classDef redText fill:#F6332C,stroke:#1D3557,color:white;

            %% Apply classes to specific nodes
            class C whiteText;
            class J redText;

            %% Link styles for clarity
            linkStyle 0 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 1 stroke:#0AB134,stroke-width:2px;
            linkStyle 2 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 3 stroke:#0AB134,stroke-width:2px;
            linkStyle 4 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 5 stroke:#0AB134,stroke-width:2px;
            linkStyle 6 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 7 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 8 stroke:#F6332C,stroke-width:2px;
            linkStyle 9 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;
            linkStyle 10 stroke:#F6332C,stroke-width:2px;
            linkStyle 11 stroke:#0AB134,stroke-width:2px;
            linkStyle 12 stroke:#112380,stroke-width:4px,stroke-dasharray:15,10;

            `;
          break;
        default:
          this.mermaidDiagram = ''; // Default diagram (no match)
        
          setTimeout(() => {
            this.justificationDetails = message;
      
            this.errorMessage = '';
            this.isLoading = false;
            this.mermaidInitialized = true; // Mark as initialized
            // Re-render the diagram
            this.renderMermaidDiagram();
          }, 1000);
      }
      
    }
  }
  ngAfterViewChecked() {
    this.renderMermaidDiagram(); // Ensure Mermaid diagrams are always rendered
  }
  renderMermaidDiagram() {
    // Ensure the Mermaid library processes the new diagram
    setTimeout(() => {
      const mermaidElements = document.querySelectorAll('.mermaid');
      if (mermaidElements.length > 0) {
        mermaid.init(undefined, mermaidElements);
      }
    }, 0);
  }
  
  refreshPage() {
    // Reset common fields
    this.errorMessage = '';
    this.isLoading = false;
  
    // Refresh content based on the active tab
    if (this.activeTab === 'sapResponse') {
      this.userId = '';
      this.userResponse = null;
      this.extendedResponse = null;
    } else if (this.activeTab === 'justification') {
      this.userIdJustification = '';
      this.controlGroupId = '';
      this.resultFlag = '';
      this.justificationDetails = '';
      this.mermaidDiagram = ''; // Clear the mermaid diagram
      this.highlightedNodes = [];
      this.mermaidInitialized = false;
      this.isJustifyDisabled = false;
    }
  }

  /**
   * Highlight JSON keys and values with colors
   * @param json JSON object
   * @returns Highlighted JSON string
   */
  highlightJson(json: any): string {
    if (!json) return '';
    const jsonStr = JSON.stringify(json, null, 2);
    return jsonStr
      .replace(/"([^"]+)":/g, '<span class="json-key">"$1":</span>') // Keys in blue
      .replace(/: "([^"]+)"/g, (match, p1) => {
        if (p1 === 'Yes') return ': <span class="json-yes">"Yes"</span>'; // "Yes" in green
        if (p1 === 'No') return ': <span class="json-no">"No"</span>'; // "No" in red
        return `: <span class="json-value">"${p1}"</span>`; // String values in brown
      })
      .replace(/: (\d+)/g, ': <span class="json-number">$1</span>') // Numbers in purple
      .replace(/: (true|false)/g, ': <span class="json-boolean">$1</span>'); // Booleans in orange
  }
}


